export interface ClientConfig {
  backend: string;
  sso: boolean;
  ssoV1: boolean;
  ssoLabel: string;   // display name in the button e.g. "FRANKLIN TEMPLETON"
  ssoUrl: string;     // SSO redirect URL (empty string if sso: false)
  ingestion_backend?: string; // defaults to INGESTION_BACKEND_PROD when omitted
  ctg_backend?: string; // defaults to CTG_BACKEND_TEST when omitted
}

const DEFAULT_BACKEND = 'https://stage-be-prddply.continualengine.com/';
// const DEFAULT_BACKEND = 'https://clonecepoc.web.moocpedia.com/';

const INGESTION_BACKEND_TEST = 'https://ingesttst.continualengine.com/';
const INGESTION_BACKEND_PROD = 'https://ingprfl.continualengine.com/';

const CTG_BACKEND_TEST = 'https://apice-orctg.continualengine.com/';
const CTG_BACKEND_PROD = 'https://apice-orctg.continualengine.com/';

export const LOGIN_CONFIG: Record<string, ClientConfig> = {

  // ─────────────────────────────────────────────
  // COLORADO  —  BE: https://epprweb.continualengine.com/
  // ─────────────────────────────────────────────
  'coloradosprings.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'COLORADO SPRINGS',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-slc',
  },
  'valencia.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'VALENCIA',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-19vlc',
  },
  'portal.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'isu.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'INDIANA STATE UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0226usi',
  },
  'und.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'UNIVERSITY OF NORTH DAKOTA',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0526und',
  },

  // ─────────────────────────────────────────────
  // EL PASO  —  BE: https://clsprweb.continualengine.com/
  // ─────────────────────────────────────────────
  'elpaso.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'app.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'harpercollege.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'HARPER COLLEGE',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0316hr',
  },
  'miamioh.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'MIAMI UNIVERSITY',
    ssoUrl:   'https://us-central1-sso-myathina-function.cloudfunctions.net/app/login?tenant=miami',
  },
  'palmbeach.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'PALM BEACH COUNTY BOARD COUNTY COMMISSIONERS',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0325pmb',
  },
  'vt.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'VIRGINIA TECH',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-rg',
  },
  'utrgv.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'THE UNIVERSITY OF TEXAS RIO GRANDE VALLEY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0529utrgv',
  },
  'shsu.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'SAM HOUSTON STATE UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0826shsu',
  },

  // ─────────────────────────────────────────────
  // EFSA  —  BE: https://efsaweb.continualengine.com/
  // ─────────────────────────────────────────────
  'efsa-prep.netlify.app': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'efsa.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'lang-es-prep-console.netlify.app': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'coloradomountain.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'COLORADO MOUNTAIN',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-mlc',
  },
  'ft.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'FRANKLIN TEMPLETON',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sptf',
  },
  'stanford.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'STANFORD UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-ts',
  },
  'jhhs.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'JHHS',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0323jh',
  },
  'bsu.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'BALL STATE UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-270726bsu',
  },
  'uco.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'UNIVERSITY OF CENTRAL OKLAHOMA',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-2226uco',
  },


  
  // ─────────────────────────────────────────────
  // RSP & DEMO
  // ─────────────────────────────────────────────
  'rsp-prep.netlify.app': {
    backend:  'https://stgprp.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
  'demo-prep.netlify.app': {
    backend:  'https://demoprep.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
  },

  // ─────────────────────────────────────────────
  // KH
  // ─────────────────────────────────────────────
  'rsp-kh-prep.netlify.app': {
    backend:  'https://apikhbe.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },

  // ─────────────────────────────────────────────
  // Scalejustice
  // ─────────────────────────────────────────────
  'scalejustice-prep.netlify.app': {
    backend:  'https://prpbesj.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },
  'scalejustice.prep.continualengine.com': {
    backend:  'https://prpbesj.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },

  // ─────────────────────────────────────────────
  // CONSOLE PROD
  // ─────────────────────────────────────────────
  'console.prep.continualengine.com': {
    backend:  'https://prepapi.web.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },

  // ─────────────────────────────────────────────
  // STAGE
  // ─────────────────────────────────────────────
  'newstaging-prep.netlify.app': {
    backend:  'https://stgusbe.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
  'stage-vt-platform.netlify.app': {
    backend:  'https://stgusbe.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
  'staging-prod-prep.netlify.app': {
    backend:  'https://stage-be-prddply.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },

  // ─────────────────────────────────────────────
  // CLONE
  // ─────────────────────────────────────────────
  'clone-prep.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
  'clone-prep-v1.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
  'clone-prep-b1.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
    ingestion_backend: INGESTION_BACKEND_TEST,
    ctg_backend: CTG_BACKEND_TEST,
  },
};

const DEFAULT_CONFIG: ClientConfig = {
  backend:  DEFAULT_BACKEND,
  sso:      false,
  ssoV1:    false,
  ssoLabel: '',
  ssoUrl:   '',
};

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const resolvedConfig = LOGIN_CONFIG[hostname] ?? DEFAULT_CONFIG;
const resolvedIngestionBackend = resolvedConfig.ingestion_backend ?? INGESTION_BACKEND_PROD;
const resolvedCtgBackend = resolvedConfig.ctg_backend ?? CTG_BACKEND_PROD;

export const environment = {
  production: true,
  backend:    resolvedConfig.backend,
  sso:        resolvedConfig.sso,
  ssoV1:      resolvedConfig.ssoV1,
  ssoLabel:   resolvedConfig.ssoLabel,
  ssoUrl:     resolvedConfig.ssoUrl,
  ingestion_backend: resolvedIngestionBackend,
  ctg_backend: resolvedCtgBackend,
};